// theme.ts

// 1. import `extendTheme` function
import { extendTheme, StyleFunctionProps, type ThemeConfig } from '@chakra-ui/react'
import { scrollbar } from './scrollbar'

// 2. Add your color mode config
const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
}

const styles = {
  global: (_props: StyleFunctionProps) => ({
    '*': { ...scrollbar },
  }),
}

// 3. extend the theme
const theme = extendTheme({ config, styles })

export default theme